import React from 'react';
import { LinksContextProvider } from '../../MyContexts/Links_Context';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';
import ManagmentPSet from './ManagmentPSet';

const ManagmentPage = (props) => {
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
            <LinksContextProvider>
           
                <Sidenavigation1 />
                {/* <Sidenavigation1 /> */}
                <main className="body-content">
                    <Topnavigation />
                    <ManagmentPSet />
                </main>
                {/* <Quickbar /> */}
               </LinksContextProvider>
            </TheMasterContextProvider>

        </div>
    );
}

export default ManagmentPage;